
export default {
  data () {
    return {
      url: ''
    }
  },
  // watch: {
  //   $route () {
  //     console.log(this.$route.path)
  //   }
  // },
  mounted () {

  },
  methods: {
    CloseNavigation () {
      this.$emit('clicked', false)
    },
    ToPages (url) {
      this.$router.push(url)
    },
    SetLine () {
      var x = document.getElementsByClassName("line-undertext-black")
      if (x.length !== 0) x[0].classList.remove('line-undertext-black')
      this.url = window.location.pathname
      this.url.startsWith('/products') ? this.url = '/products' : ''
      switch (this.url) {
        case '/':
          document.getElementById("home").classList.add("line-undertext-black");
          break;
        case '/about':
          document.getElementById("about").classList.add("line-undertext-black");
          break;
        case '/products':
          document.getElementById("products").classList.add("line-undertext-black");
          break;
        case '/news':
          document.getElementById("news").classList.add("line-undertext-black");
          break;
        case '/contact':
          document.getElementById("contact").classList.add("line-undertext-black");
          break;
      }
    }
  }
}
